import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { dateSVC } from "app/util/date/service"
import { areSameDate } from "app/util/date/tools/common"
import { ICampaignFilters } from "campaign/model"
import { getDefaultFilters } from "campaign/store/state"
import { IPeriodFilter, getStartEndFilters } from "ui/model"
import { refreshCampaignList } from "./list"

export function getActiveFilterCount(filters: ICampaignFilters): number {
  let activeFilterCount = 0
  if (filters.name.length !== 0) {
    activeFilterCount++
  }
  if (filters.advertiserIds.length !== 0) {
    activeFilterCount++
  }
  if (filters.orderIds.length !== 0) {
    activeFilterCount++
  }
  if (filters.statuses.length !== 0) {
    activeFilterCount++
  }
  if (filters.startEndPeriod.startDate !== null || filters.startEndPeriod.endDate !== null) {
    activeFilterCount++
  }
  if (filters.creationDate.date !== null) {
    activeFilterCount++
  }
  return activeFilterCount
}

export function setCampaignFilters(
  filters: Partial<ICampaignFilters>,
  isForecast: boolean,
  isDspDeal: boolean
): Promise<void> {
  const list = isForecast
    ? getStore().getState().campaign.forecastList
    : isDspDeal
      ? getStore().getState().campaign.dspDealList
      : getStore().getState().campaign.campaignList
  return refreshCampaignList({
    isForecast,
    isDspDeal,
    filters: { ...list.filters, ...filters }
  })
}

export function clearListFilters(isForecast: boolean, isDspDeal: boolean): Promise<void> {
  return setCampaignFilters(getDefaultFilters(isForecast), isForecast, isDspDeal)
}

export function getFilterPeriodLabel({ startDate, endDate }: IPeriodFilter): string {
  const filter = getStartEndFilters().find(f => areSameDate(f.startDate, startDate) && areSameDate(f.endDate, endDate))
  if (filter) {
    return translate(filter.labelKey)
  }
  if (!startDate && !endDate) {
    return translate("label.no.filter")
  }
  if (!startDate && endDate) {
    return translate("filter.period.end", dateSVC.format(endDate))
  }
  if (!endDate && startDate) {
    return translate("filter.period.start", dateSVC.format(startDate))
  }
  return translate("filter.period.start.end", [dateSVC.format(startDate as any), dateSVC.format(endDate as any)])
}
